export const FLIGHTS_SEARCH_DAY_MIN_ADVANCE = 2
export const FLIGHTS_SEARCH_DAY_MAX_ADVANCE = 330
